import { __awaiter } from "tslib";
export function createTimeSeriesPanel(details) {
    return Object.assign({ type: "timeSeries" }, details);
}
export function createNoDataPanel(details) {
    return Object.assign({ type: "noData" }, details);
}
export function createTimeDisplayPanel(dataRange) {
    return {
        type: "timeDisplay",
        key: "time-display",
        height: "h-[90px]",
        timeSeriesData: {
            series: [
                {
                    key: "time-display",
                    color: "date-rollover",
                    strokeThickness: 1.2,
                    seriesEntry: {
                        timestamps: dataRange,
                        values: [0, 0],
                        details: {
                            type: "line",
                        },
                    },
                    legendEntry: null,
                    opacity: 0,
                },
            ],
        },
        name: "",
        padding: "5, 5, 5, 5",
        removeYAxis: true,
        showXAxis: true,
        hideLegend: true,
        hideCollapse: true,
        gridlines: {
            verticalMajor: true,
            verticalMinor: true,
        },
        isTimeDisplay: true,
    };
}
function byMergeOrder(a, b) {
    var _a, _b;
    return (((_a = a.order) !== null && _a !== void 0 ? _a : Number.MAX_SAFE_INTEGER) -
        ((_b = b.order) !== null && _b !== void 0 ? _b : Number.MAX_SAFE_INTEGER) || a.id.localeCompare(b.id));
}
/**
 * Draws the merge panels into the target panel (target config and key are kept).
 */
function mergeIntoTarget(target, mergePanels) {
    const sources = [
        target.timeSeriesData,
        ...mergePanels.map((m) => m.timeSeriesData),
    ];
    return Object.assign(Object.assign({}, target), { mergePanelIds: mergePanels.map((m) => m.id), timeSeriesData: (range) => __awaiter(this, void 0, void 0, function* () {
            const timeSeriesData = yield Promise.all(sources.map((source) => typeof source === "function" ? source(range) : source));
            return Object.assign(Object.assign({}, timeSeriesData[0]), { series: timeSeriesData.flatMap((d) => { var _a; return (_a = d === null || d === void 0 ? void 0 : d.series) !== null && _a !== void 0 ? _a : []; }) });
        }) });
}
/**
 * Returns the panels with each merge panel drawn into its target panel;
 * returns the panels as is without merge panels. Merge panels without target are ignored.
 */
export function applyMergePanels(panels, mergePanels) {
    if (mergePanels.length === 0) {
        return panels;
    }
    const byTarget = new Map();
    for (const mergePanel of mergePanels) {
        const list = byTarget.get(mergePanel.mergeInto);
        if (list) {
            list.push(mergePanel);
        }
        else {
            byTarget.set(mergePanel.mergeInto, [mergePanel]);
        }
    }
    return panels.map((panel) => {
        const list = byTarget.get(panel.key);
        return list ? mergeIntoTarget(panel, list.sort(byMergeOrder)) : panel;
    });
}
export function isSameMergePanel(a, b) {
    return (a.mergeInto === b.mergeInto &&
        a.order === b.order &&
        a.timeSeriesData === b.timeSeriesData);
}
//# sourceMappingURL=panels.js.map